import styled from '@emotion/styled'
import { colors } from 'Constants'

export default styled.h1`
  font-size: ${({ size }) => size || 2}em;
  color: ${colors.textLight};
`
